import React from 'react';
import { Login } from 'react-facebook';
import axios from 'axios';
import T from '../components/T';

class LoginButton extends React.PureComponent {
  onSuccess = (data) => {
    const { from, redirectTo, onLogin } = this.props;

    let formData = {};
    formData.first_name       = data.profile.first_name;
    formData.last_name        = data.profile.last_name;
    formData.gender           = data.profile.gender;
    formData.email            = data.profile.email;
    formData.facebook_token   = data.tokenDetail.accessToken;

    console.log('success', formData);

    if (onLogin) {
      onLogin(formData);
      return;
    }

    if (from === 'login') {
      formData.action = 'login';
      document.getElementById('loading').style.display = "block";
      axios.post('/p2p/prihlasenie/', formData).then((response) => {
        window.location.href = '/p2p/moje/';
      }).catch((error) => {
        document.getElementById('loading').style.display = "none";
        app.features.notification('.js-notification', {
          text: error.response.data.errors,
          status: 'error'
        });
      });
    }
  };

  onError = (error) => {
    // probably will not use at all
    console.log('error', error);
  };

  render() {
    return (
      <Login
        scope="email"
        onResponse={this.onSuccess}
        onError={this.onError}
      >
        <button className="c-button c-button--facebook">
          <span className="c-button__content">
            <span className="text-icon">
              <i className="icon-facebook text-icon__icon" />
              <span className="text-icon__text">
                <T msg="facebook.loginButton.label" />
              </span>
            </span>
          </span>
        </button>
      </Login>
    );
  }
}

export default LoginButton;



// WEBPACK FOOTER //
// ./app/Assets/js/features/facebook/LoginButton.js